import React from "react";
import "./LandingScreen.css";

const ContactScreen = () => {
  return (
    <div className="landing-container">
      <div className="section">
        <h2>Contact REDrones</h2>
        <p>Have questions or need assistance? We’re here to help.</p>
        <p>
          Email us at <a href="mailto:admin@redrones.ie">admin@redrones.ie</a>{" "}
          or call 087 338 2908.
        </p>
        <p>Our team is available Monday through Saturday, 9 AM to 5 PM.</p>
      </div>
    </div>
  );
};

export default ContactScreen;
